import React from 'react'

const Vector = () => {
  return (
    <svg
      width="22"
      height="24"
      viewBox="0 0 22 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.4375 1.4375C0.4375 1.22201 0.523102 1.01535 0.675476 0.862976C0.827849 0.710602 1.03451 0.625 1.25 0.625H20.75C20.9655 0.625 21.1722 0.710602 21.3245 0.862976C21.4769 1.01535 21.5625 1.22201 21.5625 1.4375V4.6875C21.5625 4.88788 21.4884 5.08117 21.3545 5.23025L14.25 13.1245V20.9375C14.2499 21.108 14.1961 21.2741 14.0964 21.4123C13.9967 21.5505 13.856 21.6539 13.6943 21.7078L8.81925 23.3328C8.69717 23.3734 8.56718 23.3845 8.43998 23.3651C8.31277 23.3457 8.192 23.2964 8.08759 23.2211C7.98319 23.1459 7.89814 23.047 7.83945 22.9325C7.78075 22.818 7.7501 22.6912 7.75 22.5625V13.1245L0.6455 5.23025C0.511613 5.08117 0.437536 4.88788 0.4375 4.6875V1.4375ZM2.0625 2.25V4.3755L9.167 12.2698C9.30089 12.4188 9.37496 12.6121 9.375 12.8125V21.4347L12.625 20.3525V12.8125C12.625 12.6121 12.6991 12.4188 12.833 12.2698L19.9375 4.3755V2.25H2.0625Z"
        fill="#D64A92"
      />
    </svg>
  )
}

export default Vector;
